var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareArrow = function SvgShareArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#share-arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.262 1.738a.785.785 0 0 0-.805-.19L2.042 6.019a.78.78 0 0 0-.535.683.775.775 0 0 0 .418.76l5.652 2.962 2.961 5.652c.14.265.4.423.693.423h.068a.78.78 0 0 0 .684-.536l4.473-13.419a.785.785 0 0 0-.19-.805h-.004Zm-.45.594L11.34 15.746c-.022.063-.072.077-.099.077-.027 0-.08 0-.108-.059L8.24 10.238 9.97 8.506a.34.34 0 0 0 0-.477.34.34 0 0 0-.477 0L7.762 9.76 2.24 6.863c-.058-.031-.063-.08-.058-.108 0-.027.013-.076.076-.099l13.415-4.468s.027-.005.036-.005c.036 0 .063.018.076.036a.108.108 0 0 1 .027.113Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "share-arrow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgShareArrow;